import React from "react";
import {
	Avatar,
	Box,
	Container,
	Flex,
	Heading,
	IconButton,
	Img,
	Link,
	ListItem,
	Text,
	UnorderedList,
} from "@chakra-ui/react";
import { FaLinkedin } from "react-icons/fa";

const TheContextGuidanceBlog: React.FC = () => (
	<>
		<Flex
			flexDirection="column"
			overflow="hidden"
			justify="center"
			height="100%"
			py={{ xs: "30px", sm: "40px", md: "60px", lg: "80px" }}
			h="100%"
			minH={{ xs: "400px", lg: "400px" }}
			maxH={{ xs: "400px", lg: "400px" }}
			pos="relative"
		>
			<Img
				pos="absolute"
				objectFit="cover"
				src="/webp/theContext-bg.webp"
				alt="members-hero"
				height="100%"
				width="100%"
			/>
			<Box
				bg="linear-gradient(78.35deg, rgba(13, 96, 81, 0.8) 18.38%, rgba(83, 92, 143, 0.8) 86.05%)"
				pos="absolute"
				height="100%"
				width="100%"
				opacity="0.7"
			/>
			<Container
				display="flex"
				as="section"
				maxW="container.xl"
				position="relative"
				zIndex="1"
				flexDir={{ xs: "column", md: "row" }}
				columnGap="24px"
				rowGap="30px"
				alignItems={{ xs: "flex-start", md: "flex-start" }}
				px={{ xs: "14px", sm: "28px", md: "45px", lg: "60px", xl: "inherit" }}
			>
				<Flex flexDir="column" rowGap="16px">
					<Heading
						color="white"
						fontSize={{ xs: "36px", sm: "42px", lg: "64px" }}
						fontWeight="800"
						lineHeight={{ xs: "35px", lg: "83px" }}
					>
						#TheContext
					</Heading>
					{/* <Heading
            color="white"
            fontSize={{ xs: '28px', sm: '34px' }}
            fontWeight="500"
            lineHeight="32px"
          >
            - By IVCA
          </Heading> */}
				</Flex>
				<Box
					w="1.5px"
					h={{ md: "200px", lg: "300px", xl: "230px" }}
					bgColor="white"
					display={{ xs: "none", md: "block" }}
				/>
				<Box
					w={{ xs: "70%", sm: "60%" }}
					h="1.5px"
					bgColor="white"
					display={{ xs: "block", md: "none" }}
				/>
				<Flex flexDir="column" rowGap="8px">
					<Heading
						as="h1"
						mb={{ xs: "10px", md: "20px" }}
						variant="reportCardTitle"
						fontSize={{ xs: "27px", sm: "29px", md: "32px", lg: "54px" }}
						color="white"
						lineHeight={{ xs: "36px", sm: "40px", md: "46px", lg: "70.2px" }}
					>
						ILPA Publishes Guidance on Continuation Funds
					</Heading>
					<Text
						fontSize={{ xs: "18px", sm: "18px", md: "20px", lg: "22px" }}
						fontWeight="600"
						color="white"
						lineHeight="28px"
					>
						Ravi Chopra
					</Text>
					<Text
						fontSize={{ xs: "18px", sm: "18px", md: "20px", lg: "22px" }}
						fontWeight="600"
						color="white"
						lineHeight="28px"
					>
						Jacqueline Eaves
					</Text>
					<Text
						fontSize={{ xs: "18px", sm: "18px", md: "20px", lg: "22px" }}
						fontWeight="600"
						color="white"
						lineHeight="28px"
					>
						Robert C. Emerson
					</Text>
					<Text
						fontSize={{ xs: "18px", sm: "18px", md: "20px", lg: "22px" }}
						fontWeight="600"
						color="white"
						lineHeight="28px"
					>
						Gregory Larkin
					</Text>
					<Text
						fontSize={{ xs: "18px", sm: "18px", md: "20px", lg: "22px" }}
						fontWeight="600"
						color="white"
						lineHeight="28px"
					>
						Brian O&apos;Neill
					</Text>
				</Flex>
			</Container>
		</Flex>
		<Container maxW="container.xl" pb="80px" pt="40px">
			<Flex
				flexDir={{ xs: "column-reverse", md: "row" }}
				px={{ xs: "8px", md: "0px" }}
			>
				<Flex
					w={{ xs: "100%", md: "27%" }}
					mt={{ xs: "32px", md: "0px" }}
					flexDir="column"
					rowGap="16px"
					mr={{ xs: "0px", md: "40px" }}
					ml={{ xs: "0px", sm: "10px" }}
					mb={{ xs: "16px", md: "8px" }}
				>
					<Heading
						fontSize="22px"
						lineHeight="22px"
						textAlign={{ xs: "center", sm: "left" }}
					>
						Follow the Authors
					</Heading>
					<Box
						w="100%"
						h="1.5px"
						bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
						my="8px"
					/>
					{[
						{
							name: "Ravi Chopra",
							position: "Partner Goodwin",
							linkedin:
								"https://www.linkedin.com/in/ravi-chopra-364b9a56/?originalSubdomain=uk",
							image:
								"https://static.levocdn.com/WGLBUT82/7087298845693157983.webp",
						},
						{
							name: "Jacqueline Eaves",
							position: "Partner Goodwin",
							linkedin:
								"https://www.linkedin.com/in/jacqui-eaves/?originalSubdomain=uk",
							image:
								"https://static.levocdn.com/WGLBUT82/7087298845688767127.webp",
						},
						{
							name: "Robert C. Emerson",
							position: "Partner Goodwin",
							linkedin: "https://www.linkedin.com/in/robertcemerson/",
							image:
								"https://static.levocdn.com/WGLBUT82/7087298845701043988.webp",
						},
						{
							name: "Gregory Larkin",
							position: "Partner Goodwin",
							linkedin: "https://www.linkedin.com/in/gtlarkin/",
							image:
								"https://static.levocdn.com/WGLBUT82/7087298845692120170.webp",
						},
						{
							name: "Brain O'Neill",
							position: "Knowledge Management Counsel, Goodwin",
							linkedin:
								"https://www.linkedin.com/in/brian-o-neill-6a5512133/?originalSubdomain=uk",
							image:
								"https://static.levocdn.com/WGLBUT82/7087298845698767512.webp",
						},
					].map((item, index) => (
						<Flex
							key={index}
							flexDir={{ xs: "column", sm: "row", md: "column" }}
							columnGap="20px"
							rowGap="16px"
						>
							<Flex
								flexDir="column"
								alignItems={{ xs: "center", sm: "flex-start" }}
								rowGap="8px"
							>
								<Box boxSize="95px" borderRadius="50%" overflow="hidden">
									<Avatar
										name={item.name}
										w="100%"
										h="100%"
										src={item.image}
										objectFit="cover"
									/>
								</Box>
								<Flex flexDir="column" rowGap="4px">
									<Heading
										variant="blogQuestion"
										textAlign={{ xs: "center", sm: "left" }}
									>
										{item.name}
									</Heading>
									<Text
										variant="blogAnswer"
										textAlign={{ xs: "center", sm: "left" }}
										fontStyle="italic"
									>
										{item.position}
									</Text>
								</Flex>
								<Flex
									columnGap={{ xs: "4px", md: "16px" }}
									justifyContent={{ xs: "center", sm: "flex-start" }}
									transform={{ xs: "translateX(12px)", sm: "none" }}
								>
									<Box alignSelf="center">
										<Link href={item.linkedin} target="_blank">
											<IconButton
												aria-label="linkedin"
												icon={
													<FaLinkedin
														size="28px"
														color="rgba(100, 100, 140, 0.6)"
													/>
												}
												variant="unstyled"
												cursor="pointer"
											/>
										</Link>
									</Box>
								</Flex>
							</Flex>
						</Flex>
					))}
				</Flex>

				<Box w={{ xs: "100%", md: "73%" }}>
					<Text variant="blogAnswer" mb="20px">
						Due to the complexity of these transactions and the broad range of
						continuation fund deals, ILPA acknowledges that the guidance may not
						be appropriate for all transactions but states that it is “intended
						to provide general parameters for well-run processes that will
						encourage productive dialogue and foster more informed
						decision-making by LPs.”
					</Text>
					<Text variant="blogAnswer" pb="20px">
						Many of the suggestions in the guidance will be familiar to private
						fund sponsors (GPs) and are already included in their continuation
						fund processes. However, it is important for market participants to
						review this latest guidance and consider whether any additional
						actions are advisable.
					</Text>
					<Text variant="blogAnswer" pb="20px">
						Furthermore, GPs that are registered with the US Securities and
						Exchange Commission (SEC) should expect additional scrutiny on
						continuation funds, including in relation to: (i) their presence on
						the SEC’s examination priorities for 2023; (ii) the newly adopted
						quarterly reporting requirement on Form PF for advisers to private
						equity funds; and (iii) the expected new rule on “adviser-led
						secondary transactions.”
					</Text>
					<Text variant="blogAnswer" pb="20px" fontWeight="700">
						The full guidance document can be accessed via ILPA’s website, and
						the main themes are outlined below.
					</Text>
					<UnorderedList>
						<ListItem mb="4px">
							<Text fontWeight="bold" variant="blogAnswer" pl={{ md: "12px" }}>
								Role of the Limited Partner Advisory Committee (LPAC)
							</Text>
						</ListItem>
						<Text
							mb="14px"
							variant="blogAnswer"
							pl={{ md: "12px", lg: "18px" }}
						>
							ILPA suggests that all conflicts associated with continuation
							funds be mitigated by the GP and approved by the LPAC, and that
							any anticipatory continuation fund language in LPAs should not
							include a presumptive waiver of conflicts.
						</Text>
						<Text
							mb="14px"
							variant="blogAnswer"
							pl={{ md: "12px", lg: "18px" }}
						>
							The guidance also makes recommendations as to how the LPAC could
							be further involved, such as being consulted at an early stage on
							the rationale of the proposed transaction, reviewing the GP’s
							selection of adviser (including the terms agreed with such
							adviser, such as compensation), and carrying out a review of the
							terms of the entire deal with the GP no less than 10 business days
							prior to the signing of the acquisition agreement.
						</Text>
						<Text
							mb="14px"
							variant="blogAnswer"
							pl={{ md: "12px", lg: "18px" }}
						>
							It also suggests that it may be appropriate for the LPAC to have
							access to independent legal or other advice (paid as a fund
							expense), particularly on more complex transactions.
						</Text>
						<ListItem mb="4px">
							<Text fontWeight="bold" variant="blogAnswer" pl={{ md: "12px" }}>
								Transparency for all LPs
							</Text>
						</ListItem>
						<Text
							mb="14px"
							variant="blogAnswer"
							pl={{ md: "12px", lg: "18px" }}
						>
							While the LPAC has an important role to play in a continuation
							fund transaction, the guidance also states that all existing LPs
							should, at an appropriate point, have parity of information with
							the new investors and the LPAC, while respecting any commercially
							sensitive information. GPs should grant all existing LPs data room
							access and provide sufficient information and time to complete
							their due diligence.
						</Text>
						<Text
							mb="14px"
							variant="blogAnswer"
							pl={{ md: "12px", lg: "18px" }}
						>
							ILPA also suggests that a fairness opinion on the value of the
							underlying assets may be beneficial to the LPs in certain
							circumstances. We note that the SEC has proposed requiring such an
							opinion with respect to each continuation fund transaction even if
							not requested by LPs.
						</Text>
						<ListItem mb="4px">
							<Text fontWeight="bold" variant="blogAnswer" pl={{ md: "12px" }}>
								Elections by Existing LPs
							</Text>
						</ListItem>
						<Text
							mb="14px"
							variant="blogAnswer"
							pl={{ md: "12px", lg: "18px" }}
						>
							Existing LPs are required to actively engage in each of these
							transactions in order to decide whether to cash out or roll their
							interest into the continuation fund. ILPA recommends that LPs
							should be given at least 30 calendar days or 20 business days to
							evaluate a transaction and make the necessary election, because
							investors may need to treat this as they would a new investment
							and may require investment committee approval. If an LP cannot
							make the election within the prescribed time frame, the default
							option should be that they cash out and receive their share of the
							sale proceeds, as they would if the assets were sold by the fund
							to a third party.
						</Text>
						<Text
							mb="14px"
							variant="blogAnswer"
							pl={{ md: "12px", lg: "18px" }}
						>
							ILPA suggests that the options provided to LPs should also include
							a “status quo” option, i.e., an option to participate in the
							continuation fund on the same headline economic terms as the
							existing fund. This could present GPs with a challenge in some
							transactions, for example where there is more than one “existing
							fund” selling assets to the continuation fund.
						</Text>
						<ListItem mb="4px">
							<Text fontWeight="bold" variant="blogAnswer" pl={{ md: "12px" }}>
								Economics
							</Text>
						</ListItem>
						<Text
							mb="14px"
							variant="blogAnswer"
							pl={{ md: "12px", lg: "18px" }}
						>
							ILPA outlines that for rolling LPs, there should be no increase in
							management fee basis or percentage, or increase in the carried
							interest rate, and no decrease in the preferred return hurdle.
							There should also be no crystallization of carry for rolling
							investors, and any carry received by the GP from those investors
							cashing out should be rolled over into the continuation fund, or
							the GP should provide a detailed explanation as to why it chose
							not to roll over all the carry received.
						</Text>
						<ListItem mb="4px">
							<Text fontWeight="bold" variant="blogAnswer" pl={{ md: "12px" }}>
								Allocation of Fees and Expenses
							</Text>
						</ListItem>
						<Text
							mb="14px"
							variant="blogAnswer"
							pl={{ md: "12px", lg: "18px" }}
						>
							ILPA recommends clear disclosure of allocation methodology for
							transaction fees and expenses, and it suggests that the GP should
							share a portion of transaction costs in cases where the GP
							benefits from additional fee revenue or a stapled commitment. If
							there is a broken deal, the allocation should conform with the
							provisions of the LPA, and costs incurred by the GP to solicit
							offers after LPAC waiver or approval should be considered a fund
							expense.
						</Text>
						<ListItem mb="4px">
							<Text fontWeight="bold" variant="blogAnswer" pl={{ md: "12px" }}>
								Recommendations for LPs
							</Text>
						</ListItem>
						<Text
							mb="14px"
							variant="blogAnswer"
							pl={{ md: "12px", lg: "18px" }}
						>
							Interestingly, ILPA has set out certain recommendations to help
							LPs anticipate a continuation fund process, a clear sign that it
							believes these transactions will continue to evolve and form an
							important part of the private funds world. They include
							establishing protocols for assessing and approving continuation
							fund deals, working with GPs on expectations around timing and
							disclosures, requesting materials on the rationale behind the
							transaction as part of their due diligence, and building in
							questions regarding possible continuation funds in their due
							diligence processes for new fund investments.
						</Text>
					</UnorderedList>
				</Box>
			</Flex>
			<Box w="100%" h="1.5px" mt="16px" mb="8px" bgColor="gray.700" />
			<Text variant="blogAnswer" fontStyle="italic" p="12px 12px 0px">
				<Heading variant="blogQuestion" fontStyle="normal" as="span">
					#TheContext by IVCA{" "}
				</Heading>
				– features opinion makers from the alternate investing industry with
				strong focus on India as investment destination. Watch this space for
				viewpoints on investment themes, emerging trends, economic analysis and
				latest industry insights.
			</Text>
			<Heading
				variant="blogQuestion"
				lineHeight="30px"
				pt="16px"
				fontStyle="italic"
				p="12px 12px 0px"
			>
				Content in this section is curated by team IVCA. To share feedback,
				connect with &nbsp;
				<Link
					href="mailto:paromita.sinha@ivca.in"
					target="_blank"
					style={{ color: "blue", textDecoration: "underline" }}
				>
					paromita.sinha@ivca.in
				</Link>
			</Heading>
		</Container>
	</>
);

export default TheContextGuidanceBlog;
